import "./footer_module__content.scss"

